import * as React from "react";
import Button from "@mui/material/Button";
import {
  Dialog,
  Box,
  Typography,
  Stack,
  OutlinedInput,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Loader from "./../../components/Loader";
import Slide from "@mui/material/Slide";

import {
  isEmpty,
  getErrorString,
  checkExtension,
  hasPremium,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import notifier from "../Notifier";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmMusicNft(props) {
  const { t } = useTranslation("common");
  const [platform, setPlatform] = React.useState("Hedera");
  const [currency, setCurrecy] = React.useState("siki");
  const history = useHistory();
  const { bal, hbar, matic, near } = useSelector((state) => state.balance);
  const [amount, setAmount] = React.useState(0);
  const [inUsd, setInUsd] = React.useState(0);
  const [charge, setCharge] = React.useState({});
  const [nfts, setNfts] = React.useState(null);
  const [discountString, setDiscountString] = React.useState("");
  const isPremium = hasPremium();
  const [confirm, setConfirm] = React.useState(false);

  const [totlaAmount, setTotlaAmount] = React.useState("");
  const dispatch = useDispatch();
  const [checkBalance, setCheckBalance] = React.useState(isPremium ? 40 : process.env.SK_CHARGES_AUDIONFT);

  const handleChange = (event) => {
    calculate(event.target.value, false);
    setCurrecy(event.target.value);
    // if (event.target.value === "siki" && bal < parseInt(amount))
    //   notifier.info("You don't have sufficient SIKI tokens to create nft.");
    // else if (event.target.value === "hbar" && hbar < parseInt(amount))
    //   notifier.info("You don't have sufficient HBar tokens to create nft.");
  };
  const getChanges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response["result"]) {
        setCharge({ ...response["result"] });
        setInUsd(1 / response["result"]["rate"]);
        let discount =
          (response["result"]["sikiOff"] / 100) *
          response["result"]["audioNFT"];

        if (isPremium)
          discount =
            discount +
            (response["result"]["premiumOffMusic"] / 100) *
              response["result"]["audioNFT"];
        const total = response["result"]["audioNFT"] - discount;
        const premiumOffMusic = isPremium
          ? `${response["result"]["premiumOffMusic"]}% ${t("off")} +`
          : "";
        setDiscountString(
          `${response["result"]["audioNFT"]} + ${premiumOffMusic}  ${response["result"]["sikiOff"]}% off = ${total} SIKI Coins`
        );
        setTotlaAmount(
          `${total.toFixed(2)} SIKI tokens ${t("nftPopup.text10")}`
        );
        // setAmount(total * response["result"]["rate"]);
        setAmount(response["result"]["audioNFT"] * response["result"]["rate"]);
      }
    } catch (error) {}
  };
  const calculate = async (currency, submit) => {
    if (charge["audioNFT"] && currency === "siki") {
      setInUsd(1 / charge["rate"]);
      let discount = (charge["sikiOff"] / 100) * charge["audioNFT"];

      if (isPremium)
        discount =
          discount + (charge["premiumOffMusic"] / 100) * charge["audioNFT"];
      const total = charge["audioNFT"] - discount;
      const premiumOffMusic = isPremium
        ? `${charge["premiumOffMusic"]}% ${t("off")} +`
        : "";
      setDiscountString(
        `${charge["audioNFT"]} + ${premiumOffMusic}  ${charge["sikiOff"]}% off = ${total} SIKI Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} SIKI tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["rate"]);
      setAmount(charge["audioNFT"] * charge["rate"]);
      setCheckBalance(total);
    } else if (charge["audioNFTInHbar"] && currency === "hbar") {
      setInUsd(1 / charge["hbarValueInUsd"]);
      let discount = 0;

      if (isPremium)
        discount = (charge["premiumOffMusic"] / 100) * charge["audioNFTInHbar"];
      const total = charge["audioNFTInHbar"] - discount;
      const premiumOffMusic = isPremium
        ? `${charge["premiumOffMusic"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["audioNFTInHbar"].toFixed(2)} HBar Coins`
          : `${charge["audioNFTInHbar"].toFixed(
              2
            )} + ${premiumOffMusic}= ${total.toFixed(2)} HBar Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} Hbar tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["audioNFTInHbar"] * charge["hbarValueInUsd"]);
      setCheckBalance(total.toFixed(2));
    } else if (charge["playlistNFTInMatic"] && currency === "matic") {
      setInUsd(1 / charge["maticValueInUsd"]);
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["audioNFTInMatic"];
      const total = charge["audioNFTInMatic"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["audioNFTInMatic"].toFixed(2)} MATIC Coins`
          : `${charge["audioNFTInMatic"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} MATIC Coins`
      );
      setTotlaAmount(
        `${total.toFixed(2)} MATIC tokens ${t("nftPopup.text10")}`
      );
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["audioNFTInMatic"] * charge["maticValueInUsd"]);
      setCheckBalance(total.toFixed(2));
    } else {
      setInUsd(1 / charge["nearValueInUsd"]);
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["audioNFTInNear"];
      const total = charge["audioNFTInNear"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["audioNFTInNear"].toFixed(2)} NEAR Coins`
          : `${charge["audioNFTInNear"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} NEAR Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} NEAR tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["audioNFTInNear"] * charge["nearValueInUsd"]);
      setCheckBalance(total.toFixed(2));
    }
  };
  React.useEffect(() => {
    getChanges();
  }, []);

  const showConirm = () => {
    if (currency === "siki" && bal.toFixed(2) < checkBalance) {
      notifier.error(t("notifier.error.toast19"));
    } else if (currency === "hbar" && hbar.toFixed(2) < checkBalance) {
      notifier.error(t("notifier.error.toast19"));
    } else if (currency === "matic" && matic.toFixed(2) < checkBalance) {
      notifier.error(t("notifier.error.toast19"));
    } else if (currency === "near" && near.toFixed(2) < checkBalance) {
      notifier.error(t("notifier.error.toast19"));
    } else {
      setConfirm(true);
    }
  };
  const handlePlatformChange = (event) => {
    setPlatform(event.target.value);
  };
  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(false)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(false)}
        PaperProps={{
          style: {
            // backgroundColor: "#1E1E1E",
            // backgroundColor: "#171515",
            background: "#171515",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 6,

            margin: "0",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        {confirm && totlaAmount ? (
          <Stack style={{ backgroundColor: "#1E1E1E" }}>
            <DialogContent>
              <DialogContentText
                color="default"
                align="center"
                id="alert-dialog-slide-description"
              >
                {totlaAmount}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ width: "150px", padding: "10px 45px !important" }}
                onClick={() => props.handleClose(false)}
                color="default"
              >
                {t("cancel")}
              </Button>
              <Button
                style={{ width: "150px", padding: "10px 45px !important" }}
                variant="contained"
                color="primary"
                onClick={() =>
                  props.handleClose(
                    true,
                    currency,
                    nfts,
                    !props.platform ? platform : props.platform
                  )
                }
              >
                {t("confirm")}
              </Button>
            </DialogActions>
          </Stack>
        ) : (
          <Stack spacing={1}>
            <Stack sx={{ padding: "16px" }} spacing={1}>
              <Stack>
                <Typography color="default" className="fs-14">
                  $ {amount.toFixed(2)} {t("nftPopup.text3")}
                </Typography>
                <Typography color="default" className="fs-14">
                  {t("nftPopup.text4")}
                </Typography>
              </Stack>
              {inUsd ? (
                <Typography
                  sx={{
                    color: "#F48706 !important",
                    padding: "5px",
                    fontSize: "12px !important",
                  }}
                >
                  $1 = {inUsd.toFixed(2)} {currency.toUpperCase()} Coins
                </Typography>
              ) : null}
              {!props.platform ? (
                <Stack>
                  <div>
                    <span
                      style={{
                        display: "flex",
                        fontSize: "16px",
                      }}
                    >
                      {t("nftPopup.text5")}
                    </span>
                  </div>
                  <RadioGroup
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                    aria-labelledby="currency type"
                    name="select token type"
                    value={platform}
                    onChange={handlePlatformChange}
                  >
                    <FormControlLabel
                      value="Hedera"
                      control={<Radio color="primary" />}
                      label={
                        <Typography color="default" className="fs-13 _cp">
                          Hedera
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Polygon"
                      control={<Radio color="primary" />}
                      label={
                        <Typography color="default" className="fs-13 _cp">
                          Polygon
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Near"
                      control={<Radio color="primary" />}
                      label={
                        <Typography color="default" className="fs-13 _cp">
                          Near
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Stack>
              ) : null}

              <Stack>
                <Typography className="fs-14 " color="default">
                  {t("nftPopup.text6")}
                </Typography>

                <RadioGroup
                  sx={{
                    display: "grid",
                    justifyContent: "space-between",
                    gridTemplateColumns: "auto auto auto",
                  }}
                  aria-labelledby="currency type"
                  name="select token type"
                  value={currency}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="siki"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        SIKI Coins
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="hbar"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        HBar
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="matic"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        MATIC
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="near"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        Near
                      </Typography>
                    }
                  />
                </RadioGroup>
                <Typography className="fs-13 " color="default">
                  {t("get")} {charge["sikiOff"]}% {t("nftPopup.text7")} SIKI
                  Tokens
                </Typography>
                <Typography
                  className="fs-13 "
                  sx={{
                    color: "#F48706 !important",

                    fontSize: "13px !important",
                  }}
                >
                  {discountString}
                </Typography>
              </Stack>
              <Stack spacing={1}>
                <Typography className="fs-14" color="default">
                  {t("nftPopup.text8")}
                </Typography>
                <OutlinedInput
                  sx={{ height: "50px" }}
                  type="number"
                  autoFocus
                  margin="dense"
                  id="name"
                  value={nfts}
                  onChange={(e) => {
                    setNfts(e.target.value);
                  }}
                  onKeyDown={(e) =>
                    ["e", "E", "+", "-", "."].includes(e.key) &&
                    e.preventDefault()
                  }
                  placeholder={t("nftPopup.text9")}
                  inputProps={{ min: 1 }}
                  autoComplete="off"
                />
              </Stack>
              <DialogActions sx={{ justifyContent: "space-between" }}>
                <Button
                  sx={{
                    maxWidth: "150px",
                    padding: "10px 35px",
                    cursor: "pointer",
                  }}
                  color="default"
                  onClick={() => props.handleClose(false)}
                >
                  {t("cancel")}
                </Button>
                <Button
                  sx={{
                    maxWidth: "150px",
                    padding: "10px 35px",
                    cursor: "pointer",
                  }}
                  variant="contained"
                  color="primary"
                  disabled={!nfts || nfts < 1}
                  onClick={showConirm}
                >
                  {t("confirm")}
                </Button>
              </DialogActions>
            </Stack>
          </Stack>
        )}
      </Dialog>
    </div>
  );
}
